import {CompanyEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";

export type BaseCompanyMultiSelectProps = BaseEntityMultiSelectProps<CompanyEntity>;

export const BaseCompanyMultiSelect = (props: BaseCompanyMultiSelectProps) => {
    return <BaseEntityMultiSelect {...props} />;
};
